export interface SearchDoc {
  id: string
  title: string
  section: string
  sectionLabel: string
  headings: string[]
  content: string
  path: string
}

export const searchDocs: SearchDoc[] = [
  {
    "id": "upload",
    "title": "Upload",
    "section": "file-storage",
    "sectionLabel": "File Storage",
    "headings": [
      "Upload",
      "Serve Files",
      "Protected File Tokens",
      "S3 Configuration",
      "Thumbnail Generation",
      "Storage Drivers"
    ],
    "content": "Upload files using multipart form data. Supports local and S3-compatible backends.",
    "path": "/docs/file-storage/upload"
  },
  {
    "id": "serve-files",
    "title": "Serve Files",
    "section": "file-storage",
    "sectionLabel": "File Storage",
    "headings": [
      "Serve Files"
    ],
    "content": "Serve files directly with thumbnail and download query parameters.",
    "path": "/docs/file-storage/serve-files"
  },
  {
    "id": "protected-tokens",
    "title": "Protected Tokens",
    "section": "file-storage",
    "sectionLabel": "File Storage",
    "headings": [
      "Protected File Tokens"
    ],
    "content": "Generate time-limited signed tokens for files behind view rules.",
    "path": "/docs/file-storage/protected-tokens"
  },
  {
    "id": "s3-configuration",
    "title": "S3 Configuration",
    "section": "file-storage",
    "sectionLabel": "File Storage",
    "headings": [
      "S3 Configuration",
      "Thumbnail Generation",
      "Storage Drivers"
    ],
    "content": "Configure AWS S3, MinIO, DigitalOcean Spaces, or any S3-compatible service.",
    "path": "/docs/file-storage/s3-configuration"
  },
  {
    "id": "websocket",
    "title": "WebSocket",
    "section": "realtime",
    "sectionLabel": "Realtime",
    "headings": [
      "WebSocket",
      "Server-Sent Events",
      "Subscriptions",
      "Disconnect Cleanup"
    ],
    "content": "Bidirectional WebSocket realtime with per-channel subscriptions for record changes.",
    "path": "/docs/realtime/websocket"
  },
  {
    "id": "server-sent-events",
    "title": "Server-Sent Events",
    "section": "realtime",
    "sectionLabel": "Realtime",
    "headings": [
      "Server-Sent Events (SSE)",
      "Subscription Channels"
    ],
    "content": "Unidirectional server push over HTTP for dashboards and live updates.",
    "path": "/docs/realtime/server-sent-events"
  },
  {
    "id": "subscriptions",
    "title": "Subscriptions",
    "section": "realtime",
    "sectionLabel": "Realtime",
    "headings": [
      "Subscription Channels"
    ],
    "content": "Subscribe to collections.posts.records or specific records with predictable channel naming.",
    "path": "/docs/realtime/subscriptions"
  },
  {
    "id": "file-format",
    "title": "File Format",
    "section": "migrations",
    "sectionLabel": "Migrations",
    "headings": [
      "Directory Structure",
      "Migration File Format",
      "Running Migrations",
      "Rollback"
    ],
    "content": "JavaScript migrations in pb_migrations/ with up and down functions.",
    "path": "/docs/migrations/file-format"
  },
  {
    "id": "running-migrations",
    "title": "Running Migrations",
    "section": "migrations",
    "sectionLabel": "Migrations",
    "headings": [
      "Running Migrations"
    ],
    "content": "Run migrations automatically on server start, via CLI, or programmatically.",
    "path": "/docs/migrations/running-migrations"
  },
  {
    "id": "rollback",
    "title": "Rollback",
    "section": "migrations",
    "sectionLabel": "Migrations",
    "headings": [
      "Rollback"
    ],
    "content": "Rollback migrations using the down() function with a configurable count.",
    "path": "/docs/migrations/rollback"
  },
  {
    "id": "programmatic-api",
    "title": "Programmatic API",
    "section": "migrations",
    "sectionLabel": "Migrations",
    "headings": [
      "Running Migrations"
    ],
    "content": "Run and rollback migrations programmatically from your TypeScript code.",
    "path": "/docs/migrations/programmatic-api"
  },
  {
    "id": "js-hooks-setup",
    "title": "JavaScript Hooks Setup",
    "section": "javascript-hooks",
    "sectionLabel": "JavaScript Hooks",
    "headings": [
      "Available Hook Events",
      "Available Globals",
      "Examples",
      "Sandbox Limitations"
    ],
    "content": "Drop .js files into pb_hooks/ to extend behavior in a sandboxed Node VM.",
    "path": "/docs/javascript-hooks/setup"
  },
  {
    "id": "available-events",
    "title": "Available Events",
    "section": "javascript-hooks",
    "sectionLabel": "JavaScript Hooks",
    "headings": [
      "Available Hook Events"
    ],
    "content": "Hooks: onBootstrap, onServe, onRecordCreate, onRecordUpdate, onRecordDelete.",
    "path": "/docs/javascript-hooks/available-events"
  },
  {
    "id": "globals",
    "title": "Globals",
    "section": "javascript-hooks",
    "sectionLabel": "JavaScript Hooks",
    "headings": [
      "Available Globals",
      "Examples"
    ],
    "content": "Sandboxed globals: $app, console, require, Buffer, JSON, Date.",
    "path": "/docs/javascript-hooks/globals"
  },
  {
    "id": "api-collections",
    "title": "API Collections",
    "section": "api-reference",
    "sectionLabel": "API Reference",
    "headings": [
      "Base URL",
      "Authentication",
      "Collections",
      "Records",
      "Auth",
      "Admin",
      "Files",
      "Other"
    ],
    "content": "Complete HTTP API reference for Solarch endpoints. All endpoints return JSON.",
    "path": "/docs/api-reference/collections"
  },
  {
    "id": "api-records",
    "title": "API Records",
    "section": "api-reference",
    "sectionLabel": "API Reference",
    "headings": [
      "Records"
    ],
    "content": "List, get, create, update, delete records with filter, sort, and vector search.",
    "path": "/docs/api-reference/records"
  },
  {
    "id": "api-auth",
    "title": "API Auth",
    "section": "api-reference",
    "sectionLabel": "API Reference",
    "headings": [
      "Auth"
    ],
    "content": "Auth endpoints: password, OAuth2, OTP, MFA setup and verify, refresh.",
    "path": "/docs/api-reference/auth"
  },
  {
    "id": "api-admin",
    "title": "API Admin",
    "section": "api-reference",
    "sectionLabel": "API Reference",
    "headings": [
      "Admin"
    ],
    "content": "Admin login, refresh, password reset, and user impersonation endpoints.",
    "path": "/docs/api-reference/admin"
  },
  {
    "id": "api-files",
    "title": "API Files",
    "section": "api-reference",
    "sectionLabel": "API Reference",
    "headings": [
      "Files"
    ],
    "content": "File token generation, upload, download, and delete endpoints.",
    "path": "/docs/api-reference/files"
  },
  {
    "id": "api-settings",
    "title": "API Settings",
    "section": "api-reference",
    "sectionLabel": "API Reference",
    "headings": [
      "Other"
    ],
    "content": "Batch operations, realtime, health check, logs, backups, and settings endpoints.",
    "path": "/docs/api-reference/settings"
  },
  {
    "id": "introduction",
    "title": "Introduction",
    "section": "overview",
    "sectionLabel": "Overview",
    "headings": [
      "Solarch Documentation: Introduction",
      " The Solarch Philosophy",
      "Solarch Solves This",
      "️ Architectural Overview",
      "1. `data.db` (Application Database)",
      "2. `auxiliary.db` (System Database)",
      " Core Pillars of Solarch",
      "1. Dual-Database SQLite Engine",
      "2. Zero-Boilerplate REST CRUD APIs",
      "3. Multi-Method Authentication & Authorization",
      "4. Macro-Based Security Rule Engine",
      "5. Native Realtime Event Broadcasting",
      "6. Built-In AI & Vector Search Engine",
      "7. Embedded React Admin UI",
      " Solarch vs. Other Options",
      " Next Steps"
    ],
    "content": "Welcome to Solarch, an all-in-one, high-performance Backend-as-a-Service (BaaS) framework designed specifically for TypeScript and Node.js....",
    "path": "/docs/overview/introduction"
  },
  {
    "id": "getting-started",
    "title": "Getting Started",
    "section": "overview",
    "sectionLabel": "Overview",
    "headings": [
      "Solarch Documentation: Getting Started",
      " Prerequisites",
      "️ Step 1: Initialize Your Project",
      " Step 2: Create the Server Entry Point",
      " Step 3: Run the Server",
      " Step 4: Create Initial Admin Superuser",
      "️ Step 5: Create a Collection Programmatically",
      " Step 6: Test API Endpoints with `curl`",
      "1. Register a New End-User Account",
      "2. Authenticate & Obtain JWT Token",
      "3. Create a New Article (Authenticated)",
      "4. Fetch Articles with Relation Expansion",
      " Congratulations!",
      "Next Recommended Reading"
    ],
    "content": "This guide will walk you through building a complete, production-ready backend API from scratch using Solarch and TypeScript in under 5 minutes....",
    "path": "/docs/overview/getting-started"
  },
  {
    "id": "installation",
    "title": "Installation",
    "section": "overview",
    "sectionLabel": "Overview",
    "headings": [
      "Solarch Documentation: Installation & Setup",
      " System Requirements",
      " Installation Methods",
      "Method 1: Global CLI Installation (Recommended for Local Dev)",
      "Global installation via npm",
      "Verify CLI version",
      "Method 2: Project Dependency (Recommended for Monorepos & Apps)",
      "Using npm",
      "Using pnpm",
      "Using yarn",
      "Installing Development Dependencies",
      "Method 3: Direct CLI Execution with `npx`",
      "Start dev server on port 8090",
      "Interactively scaffold a new project",
      "️ Scaffolding a New Project (`solarch init`)",
      "Interactive Setup Wizard:",
      " Docker Container Installation",
      "Standard Multi-Stage `Dockerfile`",
      "Stage 1: Build stage",
      "Copy dependency definitions",
      "Install dependencies (including devDependencies for compilation)",
      "Copy application source code",
      "Compile TypeScript",
      "Stage 2: Production runtime stage",
      "Install production dependencies only",
      "Copy compiled dist outputs from builder stage",
      "Expose HTTP port",
      "Mount persistent volume for SQLite data directory",
      "Launch production server",
      "Container Orchestration with `docker-compose.yml`",
      " Verification & Diagnostics"
    ],
    "content": "This guide details all methods for installing, configuring, and running Solarch in local development, continuous integration (CI), and containerized p...",
    "path": "/docs/overview/installation"
  },
  {
    "id": "project-structure",
    "title": "Project Structure",
    "section": "overview",
    "sectionLabel": "Overview",
    "headings": [
      "Solarch Documentation: Project Structure & Architecture",
      " Standard Directory Layout",
      "️ Dual-Database File Architecture",
      "1. `data.db` (Application Database)",
      "2. `auxiliary.db` (System & Audit Database)",
      " `pb_hooks/` (Server JavaScript Hooks)",
      "Example Hook (`pb_hooks/main.js`):",
      "️ `pb_migrations/` (Version-Controlled Migrations)",
      " `pb_data/storage/` (File Storage Directory)"
    ],
    "content": "This guide explains the directory layout, database file organization, and structural architecture of a Solarch application.",
    "path": "/docs/overview/project-structure"
  },
  {
    "id": "cli",
    "title": "CLI Reference",
    "section": "overview",
    "sectionLabel": "Overview",
    "headings": [
      "Solarch Documentation: CLI Commands Reference",
      " Global CLI Overview",
      "Global execution",
      "On-demand execution via npx",
      " Complete Commands & Subcommands Matrix",
      "️ Command Details & Flags",
      "1. `solarch serve`",
      "Supported Options:",
      "Example Usage:",
      "2. `solarch init`",
      "Options:",
      "Example:",
      "3. `solarch superuser-create`",
      "Options:",
      "Example:",
      "4. Database Migrations (`solarch migrate`)",
      "Running Pending Migrations (`migrate up`):",
      "Rolling Back Migrations (`migrate down`):",
      "Rollback 1 migration",
      "Rollback 3 migrations",
      "Checking Migration Status (`migrate status`):",
      "Creating a New Migration Template (`migrate create`):"
    ],
    "content": "This guide provides a reference for the Solarch Command-Line Interface (CLI) (solarch), including flags, subcommands, database migrations, and adminis...",
    "path": "/docs/overview/cli"
  },
  {
    "id": "setup",
    "title": "Configuration",
    "section": "configuration",
    "sectionLabel": "Configuration",
    "headings": [
      "Solarch Documentation: Configuration Reference",
      "️ Programmatic Configuration (`SolarchConfig`)",
      " Complete `SolarchConfig` Options Matrix",
      " Configuration File (`solarch.config.ts`)",
      "Example `solarch.config.ts`:",
      "️ Dynamic Settings Encryption (`SettingsEncrypt`)",
      "Configuring Encryption Key"
    ],
    "content": "This guide details all programmatic configuration options available in Solarch via the SolarchConfig interface and solarch.config.ts configuration fil...",
    "path": "/docs/configuration/setup"
  },
  {
    "id": "environment",
    "title": "Environment Variables",
    "section": "configuration",
    "sectionLabel": "Configuration",
    "headings": [
      "Solarch Documentation: Environment Variables Reference",
      " Loading Environment Variables",
      "Example .env Configuration File",
      "Admin Pre-seeding",
      "AWS S3 Storage",
      "AI Integration",
      " Comprehensive Environment Variables Matrix",
      "1. Core Server & Database Setup",
      "2. Security & Token Secrets",
      "3. Automatic Admin Superuser Seeding",
      "4. AWS S3 Storage Driver Integration",
      "5. AI Assistant & Vector Tools"
    ],
    "content": "This guide details all environment variables supported by Solarch for server setup, security secrets, administrative seeding, S3 cloud storage, and AI...",
    "path": "/docs/configuration/environment"
  },
  {
    "id": "routing",
    "title": "Routing",
    "section": "api-routing",
    "sectionLabel": "API & Routing",
    "headings": [
      "Solarch Documentation: Routing & Express Integration",
      "️ Auto-Generated REST API Map",
      "1. Record CRUD Endpoints (Base & Auth Collections)",
      "2. Authentication Flow Endpoints (Auth Collections)",
      "3. System & Administrative Endpoints",
      " Custom Express Route Integration",
      "Example: Mounting Custom Express Endpoints",
      "️ Interacting with Solarch Context in Custom Routes",
      "️ Route Access Rules & Middleware Execution Lifecycle",
      " Best Practices for Routing"
    ],
    "content": "This guide details Solarch's REST routing system, auto-generated CRUD endpoints, and how to register custom HTTP routes using the underlying Express e...",
    "path": "/docs/api-routing/routing"
  },
  {
    "id": "controllers",
    "title": "Controllers",
    "section": "api-routing",
    "sectionLabel": "API & Routing",
    "headings": [
      "Solarch Documentation: Controllers & Request Handling",
      " What is a Controller in Solarch?",
      "️ Controller Architecture & File Layout",
      " Building a Custom Controller",
      "1. Define the Controller (`src/controllers/analytics.controller.ts`)",
      "️ Binding Controllers to Server Routes (`src/server.ts`)",
      "️ Handling Authentication & Authorization in Controllers",
      " Controller Best Practices"
    ],
    "content": "This guide explains how to construct clean, maintainable controller layers when extending Solarch applications with custom endpoints and business logi...",
    "path": "/docs/api-routing/controllers"
  },
  {
    "id": "middleware",
    "title": "Middleware",
    "section": "api-routing",
    "sectionLabel": "API & Routing",
    "headings": [
      "Solarch Documentation: Middleware & Request Pipeline",
      "️ Solarch Middleware Architecture",
      " Built-In Security Middleware",
      "1. Helmet (`helmet`)",
      "2. CORS (`cors`)",
      "3. Rate Limiting (`express-rate-limit`)",
      " Writing Custom Express Middleware",
      "1. Global Middleware Example: Request Processing Timer",
      "2. Authentication Guard Middleware (Protecting Custom Endpoints)",
      "Mounting the Auth Guard:",
      "3. API Key Authorization Middleware",
      " Middleware Best Practices"
    ],
    "content": "This guide explains Solarch's built-in security and execution middleware, and how to write custom Express Middleware for rate limiting, authentication...",
    "path": "/docs/api-routing/middleware"
  },
  {
    "id": "validation",
    "title": "Validation",
    "section": "api-routing",
    "sectionLabel": "API & Routing",
    "headings": [
      "Solarch Documentation: Data Validation & Error Handling",
      " Validation Layers in Solarch",
      " 1. Collection Schema Field Constraints",
      " 2. Custom Record Hook Validation",
      " Standardized API Error Response Format",
      "️ Handling Errors in Client Applications (Frontend SDK Example)"
    ],
    "content": "This guide covers Solarch's data validation engine, field constraints, custom validation logic, and standardized API error formatting.",
    "path": "/docs/api-routing/validation"
  },
  {
    "id": "database",
    "title": "Database",
    "section": "data-services",
    "sectionLabel": "Data & Services",
    "headings": [
      "Solarch Documentation: Database & Collections Architecture",
      "️ Embedded Dual-Database Architecture",
      "Database Performance Tuning (WAL Mode)",
      " Collection Types",
      "1. `base` (Standard Data Collections)",
      "2. `auth` (User Account Collections)",
      "3. `view` (Read-Only SQL View Collections)",
      " The 14 Supported Field Types",
      " Programmatic Collection Schema Creation",
      " SQL View Collections Example",
      " Connection Configuration Reference"
    ],
    "content": "This guide covers Solarch's embedded SQLite (better-sqlite3) engine, dual-database architecture, 14 field types, schema management, dynamic view colle...",
    "path": "/docs/data-services/database"
  },
  {
    "id": "services",
    "title": "Services",
    "section": "data-services",
    "sectionLabel": "Data & Services",
    "headings": [
      "Solarch Documentation: Services & Business Logic Layer",
      " What is a Service in Solarch?",
      "️ Service Layer File Structure",
      " Building a Typed Domain Service",
      "`src/services/post.service.ts`",
      " Using Services inside Controllers",
      " Direct SQLite Query Guidelines"
    ],
    "content": "This guide covers how to design modular Service classes to encapsulate database operations, complex calculations, and external integrations in Solarch...",
    "path": "/docs/data-services/services"
  },
  {
    "id": "authentication",
    "title": "Authentication",
    "section": "security-auth",
    "sectionLabel": "Security & Auth",
    "headings": [
      "Solarch Documentation: Authentication Engine",
      " Authentication Architecture Overview",
      " 1. Admin Superuser Authentication",
      "Endpoint: `POST /api/admins/auth-with-password`",
      "Successful Response (`200 OK`):",
      " 2. User Email & Password Authentication",
      "Endpoint: `POST /api/collections/users/auth-with-password`",
      "Successful Response (`200 OK`):",
      " 3. Fetching Enabled Auth Methods",
      "Endpoint: `GET /api/collections/users/methods`",
      "Successful Response (`200 OK`):",
      " 4. Passwordless One-Time Password (OTP) Auth",
      "Step 1: Request OTP Code",
      "Step 2: Authenticate with OTP Code",
      "️ 5. Multi-Factor Authentication (MFA / TOTP)",
      "Step 1: Initialize MFA Setup",
      "Step 2: Verify & Activate MFA",
      " 6. User Impersonation (Superuser Tooling)",
      "Endpoint: `POST /api/collections/users/impersonate/:recordId`",
      " Password Change Verification Rule"
    ],
    "content": "This guide covers Solarch's multi-method authentication engine, including Admin Superuser accounts, End-User Email/Password login, OAuth2 authenticati...",
    "path": "/docs/security-auth/authentication"
  },
  {
    "id": "security",
    "title": "Security",
    "section": "security-auth",
    "sectionLabel": "Security & Auth",
    "headings": [
      "Solarch Documentation: Security Rules & Application Hardening",
      "️ The Security Rule Engine",
      " Rule Syntax & Expression Values",
      " Available Macro Tokens",
      "1. Auth Context Macros (`@request.auth.*`)",
      "2. Request Data Macros (`@request.data.*`)",
      "3. Request Parameter Macros (`@request.query.*` & `@request.headers.*`)",
      "️ Rule Expression Examples",
      "Scenario 1: Multi-Tenant Workspace Rules",
      "Scenario 2: Public Blog with Author Draft Protection",
      " Defense in Depth: Core Hardening Features",
      "1. SQL Injection Protection (`validateIdentifier`)",
      "2. Password Hash Protection",
      "3. Compound IP + Identity Rate Limiting",
      "4. Protected Field Stripping",
      "5. Standardized Error Masking"
    ],
    "content": "This guide explains Solarch's declarative Security Rule Engine, @request. macro expressions, SQL injection defense mechanisms, rate limiting, and prod...",
    "path": "/docs/security-auth/security"
  },
  {
    "id": "deployment",
    "title": "Deployment",
    "section": "hosting-deployment",
    "sectionLabel": "Hosting & Deployment",
    "headings": [
      "Solarch Documentation: Production Deployment Guide",
      " Production Architecture Principles",
      " 1. Deploying to Render",
      "Step-by-Step Render Deployment:",
      "️ 2. Deploying to Fly.io",
      "`fly.toml` Configuration File:",
      "Launch Commands:",
      "Initialize Fly app",
      "Create persistent volume",
      "Deploy app",
      " 3. Deploying to Linux VPS (Ubuntu / Debian + PM2 + Nginx)",
      "Step 1: Install Node.js 20 & PM2",
      "Install Node.js 20 LTS",
      "Install PM2 process manager globally",
      "Step 2: Clone and Build Project",
      "Step 3: Configure PM2 `ecosystem.config.js`",
      "Step 4: Configure Nginx Reverse Proxy & Let's Encrypt SSL",
      "Enable free HTTPS SSL via Let's Encrypt",
      " Production Automated Backup Strategy",
      "Programmatic Backup Schedule Setup:"
    ],
    "content": "This guide details best practices for deploying Solarch backends to production environments, including cloud platform deployment (Render, Fly.io, Rail...",
    "path": "/docs/hosting-deployment/deployment"
  },
  {
    "id": "testing",
    "title": "Testing",
    "section": "hosting-deployment",
    "sectionLabel": "Hosting & Deployment",
    "headings": [
      "Solarch Documentation: Testing & Quality Assurance",
      " Testing Architecture & Isolated Test Environments",
      "Recommended Test Setup Strategy",
      " Integration Test Example (`vitest` + `supertest`)",
      "`src/__tests__/auth_and_records.test.ts`",
      " Running Tests"
    ],
    "content": "This guide details best practices for unit testing, integration testing, and API testing for Solarch applications using vitest and supertest.",
    "path": "/docs/hosting-deployment/testing"
  },
  {
    "id": "ai",
    "title": "AI SDK",
    "section": "sdks",
    "sectionLabel": "SDKs",
    "headings": [
      "Solarch AI Agent SDK",
      "Architecture Overview",
      "Agent Configuration & Initialization",
      "Native Solarch Tools",
      "Tool Execution Pipeline",
      "Execution Safety & Budget Control",
      "Multi-Tier Memory",
      "Deterministic Workflow Graphs",
      "Multi-Agent Orchestration"
    ],
    "content": "TypeScript framework for building autonomous agents, multi-step tool pipelines, and deterministic workflow graphs with @solarch/agents.",
    "path": "/docs/sdks/ai"
  },
  {
    "id": "web",
    "title": "Web SDK",
    "section": "sdks",
    "sectionLabel": "SDKs",
    "headings": [
      "Solarch Web SDK",
      "Installation & Setup",
      "Authentication",
      "Records & Collections CRUD",
      "Realtime Subscriptions",
      "File Uploads & Storage",
      "Vector Search"
    ],
    "content": "Official client library for browser applications and modern web frameworks including React, Next.js, Vue, and Svelte.",
    "path": "/docs/sdks/web"
  },
  {
    "id": "react-native",
    "title": "React Native SDK",
    "section": "sdks",
    "sectionLabel": "SDKs",
    "headings": [
      "Solarch React Native SDK",
      "Installation",
      "Initializing with Persistent Storage",
      "Mobile Authentication",
      "Realtime Mobile Subscriptions",
      "Mobile File Uploads"
    ],
    "content": "Connect React Native and Expo mobile applications to Solarch backends with mobile auth, offline persistence, and realtime listeners.",
    "path": "/docs/sdks/react-native"
  },
  {
    "id": "electron",
    "title": "Electron SDK",
    "section": "sdks",
    "sectionLabel": "SDKs",
    "headings": [
      "Solarch Electron SDK",
      "Architecture Patterns",
      "Main Process Embedded Server",
      "Preload Bridge IPC Security",
      "Renderer Process UI Interaction",
      "Secure Credential Storage"
    ],
    "content": "Build desktop applications by embedding or connecting to Solarch across Electron's Main and Renderer processes.",
    "path": "/docs/sdks/electron"
  },
  {
    "id": "tauri",
    "title": "Tauri SDK",
    "section": "sdks",
    "sectionLabel": "SDKs",
    "headings": [
      "Solarch Tauri SDK",
      "Overview",
      "Setup in Tauri Frontend",
      "Desktop Authentication & Session Persistence",
      "Realtime Events in Tauri",
      "Performance & Memory Footprint"
    ],
    "content": "Combine Tauri's lightweight Rust core with Solarch's fullstack TypeScript BaaS for high-performance desktop apps.",
    "path": "/docs/sdks/tauri"
  },
  {
    "id": "mcp",
    "title": "Model Context Protocol (MCP)",
    "section": "sdks",
    "sectionLabel": "SDKs",
    "headings": [
      "Solarch Model Context Protocol (MCP)",
      "Capabilities",
      "Available MCP Tools",
      "Configuration for AI Clients",
      "Security & Access Control"
    ],
    "content": "Model Context Protocol server enabling AI assistants, Cursor, and Claude Desktop to interact with Solarch under strict security boundaries.",
    "path": "/docs/sdks/mcp"
  }
]
